<template>
  <vs-input
      :id="id"
      :label="label"
      :data-cy="name || `input-${id}`"
      :placeholder="placegolder"
      :state="state"
      :data-vv-as="dataAs"
      v-validate="validation"
      v-model="displayValue"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
      :class="clases"
      :disabled="disabled"
      :danger="danger"
      :danger-text="dangerText"
  >
  </vs-input>
</template>
<script>
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';

export default {
  name: 'VsInputRut',
  mixins: [RutMixin],
  data() {
    return {
      isInputActive: false
    };
  },
  methods: {
    onFocus(active) {
      this.isInputActive = active;
      if (!active) {
        this.$emit('blur');
      } else {
        this.$emit('focus');
      }
    },
    cleanRut(_value) {
      return typeof _value === 'string' ? _value.replace(/[^0-9kK]+/g, '').toUpperCase() : '';
    },
    formatRut(_value, punto = false, _default = '') {
      const numberTruncate = punto ? 12 : 10;
      if (!_value) {
        return _value;
      }
      let value = _value;
      value = this.cleanRut(value);
      if (!value) return _default;
      if (value.length <= 1) return value;
      let result = `${value.slice(-4, -1)}-${value.substr(value.length - 1)}`;
      for (let i = 4; i < value.length; i += 3) result = value.slice(-3 - i, -i) + (punto ? '.' : '') + result;
      return this.truncateValue ? result.substring(0, numberTruncate) : result;
    }
  },
  computed: {
    displayValue: {
      get() {
        return this.formatRut(this.value, this.displaypunto);
      },
      set(modifiedValue) {
        this.$emit('input', this.formatRut(modifiedValue, this.valuepunto));
      }
    },
    validation() {
      if (typeof this.vValidate === 'object') {
        const validation = {
          ...this.vValidate,
          validateRut: true
        };
        return Object.entries(validation).map(([key]) => `${key}`).join('|');
      }
      return this.vValidate ? `${this.vValidate}|validateRut` : 'validateRut';
    }
  },
  props: {
    id: {
      type: String,
      requited: true
    },
    label: {
      type: String,
      requited: true
    },
    name: {
      type: String,
      requited: true
    },
    dataAs: {
      type: String
    },
    value: {
      type: String,
      default: ''
    },
    vValidate: {
      type: [String, Object],
      default: ''
    },
    placegolder: {
      type: String,
      default: '12.345.678-0'
    },
    state: {
      type: Boolean
    },
    disabled: { type: Boolean, required: false, default: false },
    valuepunto: { type: Boolean, required: false, default: false },
    displaypunto: { type: Boolean, required: false, default: false },
    truncateValue: { type: Boolean, required: false, default: false },
    clases: { type: String, required: false },
    danger: { type: [Boolean, String], required: false },
    dangerText: { type: String, required: false },
  }
};
</script>
